module.exports = __webpack_public_path__ + "static/media/language.0e8bc25f.svg";